/* Southpaw theme scripts */
(function () {
  'use strict';

  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.SOUTHPAW && window.SOUTHPAW.moneyFormat;
    var value = (cents / 100).toFixed(2);
    if (!fmt) return value;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- mobile nav ---------- */
  on($('[data-menu-toggle]'), 'click', function () {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    nav.classList.toggle('is-open');
    this.setAttribute('aria-expanded', nav.classList.contains('is-open'));
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      on(thumb, 'click', function () {
        if (main) {
          main.src = thumb.dataset.full || thumb.querySelector('img').src;
          main.alt = thumb.dataset.alt || '';
        }
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- quantity ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    $$('[data-qty-step]', wrap).forEach(function (btn) {
      on(btn, 'click', function () {
        var step = parseInt(btn.dataset.qtyStep, 10);
        var min  = parseInt(input.min || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- variant selection ---------- */
  $$('[data-variant-form]').forEach(function (form) {
    var data = $('[data-variant-json]', form);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput  = $('[data-variant-id]', form);
    var submit   = $('[data-atc]', form);
    var priceEl  = $('[data-price-current]', form);
    var wasEl    = $('[data-price-was]', form);
    var saveEl   = $('[data-price-save]', form);

    function selectedOptions() {
      return $$('[data-option-index]', form)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (i) { return i.value; });
    }

    var hasOptionInputs = $$('[data-option-index]', form).length > 0;

    function update() {
      var match;

      if (!hasOptionInputs) {
        // Single-variant product: no option radios are rendered, so there is
        // nothing to match on. Use the variant already set on the form.
        match = variants.filter(function (v) {
          return String(v.id) === String(idInput && idInput.value);
        })[0] || variants[0];
      } else {
        var opts = selectedOptions();
        match = variants.filter(function (v) {
          return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
      }

      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      if (wasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          wasEl.textContent = formatMoney(match.compare_at_price);
          wasEl.hidden = false;
          if (saveEl) {
            saveEl.hidden = false;
            saveEl.textContent = 'Save ' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
          }
        } else {
          wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? (submit.dataset.labelAdd || 'Add to cart') : 'Sold out';
      }

      var media = $('[data-gallery-main]');
      if (media && match.featured_image && match.featured_image.src) {
        media.src = match.featured_image.src;
      }

      if (history.replaceState && hasOptionInputs) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', form).forEach(function (i) { on(i, 'change', update); });
    update();
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');

  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }

  $$('[data-cart-open]').forEach(function (b) {
    on(b, 'click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      openDrawer();
    });
  });
  $$('[data-cart-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var newBody = fresh.querySelector('[data-cart-contents]');
        var oldBody = $('[data-cart-contents]');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  /* ---------- ajax add to cart ---------- */
  $$('[data-variant-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      if (!drawer) return; // fall back to normal POST when cart is a page
      e.preventDefault();
      var btn = $('[data-atc]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || 'Could not add to cart');
          return refreshCart();
        })
        .then(openDrawer)
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  });

  /* ---------- line item quantity changes inside drawer ---------- */
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: parseInt(btn.dataset.lineChange, 10) })
    }).then(refreshCart);
  });

  /* ---------- reservation countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = Date.now() + parseInt(el.dataset.countdown, 10) * 60000;
    (function tick() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left > 0) setTimeout(tick, 1000);
    })();
  });

  /* ---------- rotating quotes ---------- */
  $$('[data-quote-rotator]').forEach(function (el) {
    var items = JSON.parse(el.dataset.quoteRotator || '[]');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % items.length;
      el.style.opacity = 0;
      setTimeout(function () { el.innerHTML = items[i]; el.style.opacity = 1; }, 240);
    }, 6000);
    el.style.transition = 'opacity .24s ease';
  });
})();
